import {useEffect, useState} from 'react';

/**
 * hook for debounce component state
 * @param {any} value - value
 * @param {number} delay - delay
 * @return {any} debounced value
 */
export function useDebounceValue<V>(value: V, delay: number): V {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);
    return debouncedValue;
}
